export default "__VITE_ASSET__nfxOILSplT_DQ7QPK1bMGA__"